module.exports = __webpack_public_path__ + "img/songwriters-journal_B09MYXVMPX.b9c01835.jpg";